import { URL_CHANGE_EVENT, URL_SCROLLED_EVENT } from "../consts";

export default function changeUrlOnScroll(context) {
    context.intersectionObserverProvider.addTask({
        selector: ".js-update-url",
        oneTime: false,
        onIntersect(entry) {
            const { postUrl, headline, pageTitle, elid } = entry.target.dataset;
            context.eventBus.publish(URL_CHANGE_EVENT, {
                url: postUrl,
                id: elid,
                headline: pageTitle || headline,
                trackPageView: true,
            });
        },
    });

    context.intersectionObserverProvider.addTask({
        selector: ".js-scrolled-url",
        oneTime: false,
        onIntersect(entry) {
            const { postUrl, headline, pageTitle, elid } = entry.target.dataset;
            context.eventBus.publish(URL_SCROLLED_EVENT, {
                url: postUrl,
                id: elid,
                headline: pageTitle || headline,
            });
        },
    });


    if (context.settings.engine.changeParticleUrlScroll) {
        context.intersectionObserverProvider.addTask({
            selector: ".rebellt-item[data-href]:not([data-use-pagination=\"True\"])",
            oneTime: false,
            onIntersect(entry) {
                const { href, postId, basename } = entry.target.dataset;
                context.eventBus.publish(URL_CHANGE_EVENT, {
                    url: href,
                    id: postId,
                    headline: document.title,
                    trackPageView: context.settings.engine.trackPageViewOnParticleUrlScroll,
                });
            },
        });
    }

    return context;
}
